const useDeliveryMessage = (param) => {
  const toPST = (date) => {
    return new Date(
      date.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );
  };

  const currentTime = toPST(new Date());

  const sameDayCutoff = 11; // 11AM PST
  const nextDayCutoff = 16; // 4PM PST
  const nextDayDate = new Date(currentTime);
  nextDayDate.setDate(currentTime.getDate() + 1);
  const dayAfterTomorrow = new Date(currentTime);
  dayAfterTomorrow.setDate(currentTime.getDate() + 2);

  const getNextActiveDay = (startDate, daysActive, disabledDates) => {
    let date = new Date(startDate);
    const disabledSet = new Set(disabledDates.map((date) => date.trim()));

    for (let i = 0; i < 7; i++) {
      const jsDayIndex = date.getDay();
      const dayActiveIndex = jsDayIndex === 0 ? 7 : jsDayIndex;
      const getFormattedPSTDate = (pstDate) => {
        const year = pstDate.getFullYear();
        const month = String(pstDate.getMonth() + 1).padStart(2, "0");
        const day = String(pstDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const pstFormattedDate = getFormattedPSTDate(date);
      if (
        daysActive[dayActiveIndex - 1]?.isActive &&
        !disabledSet.has(pstFormattedDate)
      ) {
        return date;
      }
      date.setDate(date.getDate() + 1);
    }
    return null;
  };

  const matchDeliveryMessage = (date) => {
    if (!date) return null;
    const deliveryPST = date.toDateString();
    const currentPST = currentTime.toDateString();
    const nextDayPST = nextDayDate.toDateString();
    const dayAfterTomorrowPST = dayAfterTomorrow.toDateString();

    if (deliveryPST === currentPST) return "Today";
    if (deliveryPST === nextDayPST) return "Tomorrow";
    if (deliveryPST === dayAfterTomorrowPST) return "Day After Tomorrow";
    return null;
  };

  const { routeClassId, daysActive, disabledDates } = param;
  let deliveryMessage = null;
  let deliveryDate = null;

  if (routeClassId === 1) {
    // Same Day
    const targetDate =
      currentTime.getHours() < sameDayCutoff ? currentTime : nextDayDate;
    deliveryDate = getNextActiveDay(targetDate, daysActive, disabledDates);
    deliveryMessage = deliveryDate ? matchDeliveryMessage(deliveryDate) : null;
  } else if (routeClassId === 2) {
    // Next Day
    const targetDate =
      currentTime.getHours() < nextDayCutoff ? nextDayDate : dayAfterTomorrow;
    deliveryDate = getNextActiveDay(targetDate, daysActive, disabledDates);
    deliveryMessage = deliveryDate ? matchDeliveryMessage(deliveryDate) : null;
  } else if (routeClassId === 3) {
    // Regular
    deliveryDate = getNextActiveDay(
      dayAfterTomorrow,
      daysActive,
      disabledDates
    );
    deliveryMessage = deliveryDate ? matchDeliveryMessage(deliveryDate) : null;
  }

  if (deliveryMessage && deliveryDate) {
    return {
      deliveryMessage: deliveryMessage,
      deliveryDate: deliveryDate,
    };
  }

  return { deliveryMessage: null, deliveryDate: null };
};

export default useDeliveryMessage;
